import React from "react";
import { ICheckbox } from "./checkbox.d.ts";
import { Container, InputCheckBox, Label } from "./styles";
import { randomId } from "../utils/index.js";
/**
 * Componente de botões de navegação
 * @param {ICheckbox} props - Props do componente
 * @returns {JSX.Element} Componente do botão
 **/
const Checkbox = ({ checked, label, textPosition = "left", children, onChange }) => {
	const id = randomId("checkbox");

	return (
		<Container orientation={textPosition}>
			<InputCheckBox
				type="checkbox"
				name="remember"
				placeholder=" "
				checked={checked}
				onChange={onChange}
				id={id}
			/>
			{label && label.length && (
				<Label dangerouslySetInnerHTML={{ __html: label }} htmlFor={id} />
			)}
			<label htmlFor={id}>{children}</label>
		</Container>
	);
};

export default Checkbox;
